import type { CSSProperties } from 'react';
import { Toaster as Sonner, type ToasterProps } from 'sonner';
import { resolveTheme, useThemeStore } from '@/lib/theme';

/**
 * shadcn/ui sonner wrapper. The upstream version reads `next-themes`; this app
 * keeps its theme in `useThemeStore`, so the toaster follows that instead.
 */
function Toaster(props: ToasterProps) {
	const theme = useThemeStore((state) => state.theme);

	return (
		<Sonner
			theme={theme === 'system' ? 'system' : resolveTheme(theme)}
			className="toaster group"
			style={
				{
					'--normal-bg': 'var(--popover)',
					'--normal-text': 'var(--popover-foreground)',
					'--normal-border': 'var(--border)',
				} as CSSProperties
			}
			{...props}
		/>
	);
}

export { Toaster };
